<template>
  <div class="tw-bg-gray-100 tw-p-4 tw-mb-4">
    <p class="tw-mb-2">
      <strong class="tw-text-gray-700">{{ $t('Do you want to bill as B-indkomst?') }}</strong>
    </p>
    <p class="tw-mb-0">
      {{
        $t(
          "If you don't have a CVR number and want to have your income as B-indkomst instead, contact us.",
        )
      }}
    </p>
  </div>
</template>

<script setup>
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()
</script>
